import { render, staticRenderFns } from "./SstoreCate.vue?vue&type=template&id=5aec0bbc&scoped=true"
import script from "./SstoreCate.vue?vue&type=script&lang=js"
export * from "./SstoreCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aec0bbc",
  null
  
)

export default component.exports